var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.731L8.56029 15.9914C8.56029 15.9914 8.60239 16.0108 8.6177 15.9914L12.5 13",
    stroke: "#0E1111",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3732 3.55573L11.2287 1.86635C10.6213 1.38788 9.74103 1.49237 9.26256 2.09975L6.16227 6.03527C5.6838 6.64264 5.7883 7.52289 6.39567 8.00136L8.54017 9.69074C9.14755 10.1692 10.0278 10.0647 10.5063 9.45734L13.6066 5.52182C14.085 4.91445 13.9805 4.0342 13.3732 3.55573Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.96 9.23291C14.59 9.23291 14.26 9.44291 14.08 9.76291C13.44 10.9729 11.7 11.8429 9.65 11.8429C7.6 11.8429 5.86 10.9729 5.22 9.76291C5.05 9.43291 4.71 9.23291 4.34 9.23291H3C2.45 9.23291 2 9.68291 2 10.2329V16.6729C2 17.7329 2.86 18.5829 3.91 18.5829H15.38C16.44 18.5829 17.29 17.7229 17.29 16.6729V10.2329C17.29 9.68291 16.84 9.23291 16.29 9.23291H14.95H14.96Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/vote.4371a8704322eb36bdea808df19645c9.svg";
export { ForwardRef as ReactComponent };